import { useQuery } from '@tanstack/react-query';
import apis from '@api/api';
import {ScrollView, View, Platform } from 'react-native';
import { Title } from '@constants/Themed';
import { useState, useCallback, useMemo, forwardRef, useContext, useImperativeHandle, useRef } from 'react';
import GenerateSchemaForm from '@hooks/generateSchemaForm';
import BottomSheet, { BottomSheetModal, BottomSheetView } from '@gorhom/bottom-sheet';
import React from 'react';
import AnimatedLottieView from '@utils/lottieAnimation';
import styles from '@stylesheet';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import { ToolbarContext } from '@hooks/toolbarContext';
import { H5, H4, Separator } from 'tamagui';
import { StyledModal } from '@constants/Themed';

interface AddWpTypes {
  projectId: string;
  projectTitle: string;
  callback?: Function;
}

export interface AddWorkPackageRef {
  openModal: () => void;
  closeModal: () => void;
}

const AddWP = forwardRef<AddWorkPackageRef, AddWpTypes>((props, ref) => {
  const [wpSchema, setWPSchema] = useState<any>();
  const { projectId, projectTitle } = props;
  const {projectContext} = useContext(ToolbarContext);
  const modalRef = useRef<any>(null);


  const { status, data: workPackageSchema, error, isFetching } = useQuery({
    queryKey: ['workPackageSchema'],
    queryFn: async () => {
      const res = await apis.getWPSchema();
      setWPSchema(res.schema);
      return res;
    },

  });

  useImperativeHandle(ref, () => ({
    openModal: () => {
      console.log('🔵 AddWP openModal called');
      console.log('🔵 modalRef.current:', modalRef.current);
      console.log('🔵 Platform.OS:', Platform.OS);
      if (Platform.OS === 'web') {
        modalRef.current?.openModal();
      } else {
        console.log('🔵 Calling modalRef.current?.present()');
        modalRef.current?.present();
      }
    },
    closeModal: () => {
      console.log('🔵 AddWP closeModal called');
      if (Platform.OS === 'web') {
        modalRef.current?.closeModal();
      } else {
        modalRef.current?.dismiss();
      }
    }
  }), []);

  const snapPoints = useMemo(() => ['60%', '85%'], []);
  const handleSheetChanges = useCallback((index: number) => {
    console.log('handleSheetChanges', index);
  }, []);

  const renderContent = (extraCallback?: Function) => {
    if (isFetching) {
      return (
        <View style={{ flex: 1 }}>
          <AnimatedLottieView
            source={require('@assets/animations/leaf_Loader.json')}
            style={{ flex: 1, width: 100 }}
            autoPlay
            loop
          />
        </View>
      );
    }

    return (
      <GenerateSchemaForm
        schema={wpSchema}
        scrollEnabled={true}
        submitFunction={(v) => apis.addWorkPackage(v, projectId)}
        nullify={['task_list', 'index', 'team', 'start_date', 'end_date', 'createdAt', 'updated_at', 'completed', 'createdBy', 'created_by']}
        other={projectContext?.project?._id}
        extraCallBack={extraCallback}
      />
    );
  };

  if (Platform.OS !== 'web') {
    return (
      <BottomSheetModal
        ref={modalRef}
        snapPoints={snapPoints}
        onChange={handleSheetChanges}
        enablePanDownToClose={true}
        enableDismissOnClose={true}
        handleIndicatorStyle={{ backgroundColor: themeSelector() ? 'black' : 'white' }}
        backgroundStyle={{ backgroundColor: themeSelector() ? 'white' : 'black' }}
        style={styles.bottomSheet}
      >
        <BottomSheetView style={{ flex: 1 }}>
          <View style={{ flexDirection: 'row', flex: 1, maxHeight: 70, justifyContent: "center" }}>
            <H4 textWrap='wrap' numberOfLines={2} style={{ fontSize: 22, textAlign: "center", paddingHorizontal: "10%" }}>Add a new work package to {projectTitle}</H4>
          </View>
          <Separator />
          <View style={{ flex: 1, minWidth: '80%', padding: 20 }}>
            {renderContent((data) => {
              if (props.callback) { props.callback(data) };
              console.log(data);
              projectContext?.updateFn(data);
              if (typeof modalRef === 'object' && modalRef?.current?.dismiss) {
                modalRef.current.dismiss();
              }
            })}
          </View>
        </BottomSheetView>
      </BottomSheetModal>
    );
  } else {
    return (
      <StyledModal ref={modalRef} title={
        'Add a new work package to ' + projectTitle
      }
        caption='Work packages help you organise tasks and phases of a project.'
        style={{ flex: 1 }}>
        {error || !workPackageSchema ? (
          <AnimatedLottieView
            source={require('@assets/animations/leaf_Loader.json')}
            style={{ flex: 1, width: 100 }}
            autoPlay
            loop
          />
        ) : (
            <ScrollView style={{ left: 15, backgroundColor: "transparent" }}>
              {renderContent((data) => { 
                if (props.callback) { props.callback(data) }; 
                console.log(data); 
                projectContext?.updateFn(data);
                // For web modal, we'll need to use a different approach to close
                if (typeof modalRef === 'object' && modalRef?.current) { 
                  // Try common modal close methods
                  if ('close' in modalRef.current && typeof modalRef.current.close === 'function') {
                    modalRef.current.close();
                  } else if ('closeModal' in modalRef.current && typeof modalRef.current.closeModal === 'function') {
                    modalRef.current.closeModal();
                  }
                }
              })}
            </ScrollView>
        )}
      </StyledModal>
    );
  }
});

export default AddWP;
